import React, {Component} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {loadSession} from '../../modules/auth/actions/session';

class PrivateRoute extends Component {
	componentWillMount() {
		const {loadSession} = this.props;
		loadSession();
	}

	render() {
		const {component: Component, session, ...rest} = this.props;

		const loading = (
			<div className="overlay">
				<i className="fa fa-refresh fa-spin"/>
			</div>
		);

		const content = (
			<Route
				{...rest}
				render={
					props => (
						(session && session.token)
							? <Component {...props}/>
							: <Redirect to={{
								pathname: '/auth/login',
								state: { from: props.location }
							}}/>
					)
				}
			/>
		);

		return !session.isLoading ? content : (
			<div className="overlay-wrapper">
				{loading}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	session: state.session
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadSession
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
